export const a11yStrings = {
  enablePatterns: 'Enable Patterns',
  disablePatterns: 'Disable Patterns',
  showDataTable: 'Show Data Table'
};